var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('am2-dropdown-binder',{attrs:{"align":_vm.align,"pixel-shift":10,"button-name":"am2-expand-icon-button","button-props":_vm.buttonProps,"dropdown-props":{
    items: _vm.items,
  }},on:{"select":_vm.handleItemSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }